<template>
  <div id="customer">
    <el-form
      id="queryForm"
      :inline="true"
      :model="queryForm"
      class="demo-form-inline"
    >
      <RoleSelector ref="roleSelector" label="角色" />
      <el-form-item label="用户名">
        <el-input v-model="queryForm.userName" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="queryForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData.list"
      style="width: 100%"
      :default-sort="{ prop: 'date', order: 'descending' }"
      border
    >
      <el-table-column prop="userName" label="用户名"></el-table-column>
      <el-table-column prop="mobile" label="手机号" sortable></el-table-column>
      <el-table-column prop="locked" label="是否锁定"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.$index, scope.row)"
          >
            <i class="el-icon-key" />
          </el-button>
          <!-- <el-button size="mini" type="primary" @click="changePassword(scope.row)"><i class="el-icon-lock" /></el-button>
          <el-button size="mini" type="danger" @click="removeCustomer(scope.row)"><i class="el-icon-delete" /></el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="query"
      @size-change="changeSize"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10, 20, 30, 40, 50]"
      :total="tableData.total"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog
      :title="'分配权限给：' + userData.userName"
      :visible.sync="updateFormVisible"
      :width="dialogWidth"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="用户角色">
          <RoleTree ref="roleTree" :default-tree="roleTree" />
        </el-tab-pane>
        <el-tab-pane label="临时权限">
          <PermissionTree ref="permissionTree" :default-tree="permissionTree" />
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCustomer">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import MenuSelector from "@/components/system/MenuSelector.vue";
import RoleSelector from "@/components/system/RoleSelector.vue";
import PermissionTree from "@/components/system/PermissionTree.vue";
import RoleTree from "@/components/system/RoleTree.vue";
export default {
  components: {
    //MenuSelector,
    RoleSelector,
    PermissionTree,
    RoleTree,
  },
  data() {
    return {
      tableData: [],
      userData: {},
      permissionTree: [],
      roleTree: [],
      updateFormVisible: false,
      dialogWidth: "600px",
      queryForm: {},
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.query();
    },
    query() {
      if (this.$refs.roleSelector) {
        this.queryForm.roleId = this.$refs.roleSelector.selectedId;
      }
      var self = this;
      this.$axios
        .get("system/user/query", { params: self.queryForm })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateFormVisible = true;
      this.userData.userName = row.userName;
      this.userData.userId = row.id;
      var self = this;
      this.$axios
        .get("system/user/permission?userId=" + row.id)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.$refs.permissionTree.setChecked(
              response.data.data.permissions
            );
            self.$refs.roleTree.setChecked(response.data.data.roles);
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    updateCustomer() {
      this.userData.permissions = this.$refs.permissionTree.getChecked();
      this.userData.roles = this.$refs.roleTree.getChecked();
      var self = this;
      this.$axios
        .post("system/permission/assign", self.userData)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success",
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
  },
  created: function () {
    this.query();
    var self = this;
    this.$axios.get("system/permission/tree").then(function (response) {
      if (response.data.errorCode == "00000") {
        self.permissionTree = response.data.data;
      } else {
        self.$message.error(response.data.errorMsg);
      }
    });

    this.$axios.get("system/role/query").then(function (response) {
      if (response.data.errorCode == "00000") {
        self.roleTree = response.data.data;
      } else {
        self.$message.error(response.data.errorMsg);
      }
    });
  },
};
</script>

<style scoped>
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>